import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';

const ADMIN_PLAN_TEMPLATES_QUERY = gql`
  query AdminPlanTemplates {
    adminPlanTemplates {
      id
      name
      slug
      planType
      status
      updatedAt
    }
  }
`;

const PlanBuilderTemplatesIndex = () => {
  const { data, loading, error } = useQuery(ADMIN_PLAN_TEMPLATES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const templates = data?.adminPlanTemplates || [];

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>Plan Builder Templates</Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        <Link to="/admin/plan_builder/progress">Go to progress</Link>
      </Typography>

      {error && <Typography color="error">Error: {error.message}</Typography>}
      {loading && <Typography color="textSecondary">Loading...</Typography>}

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Slug</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Updated</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templates.map((t) => (
              <TableRow key={t.id} hover>
                <TableCell>
                  <Link to={`/admin/plan_builder/templates/${t.id}`}>{t.name}</Link>
                </TableCell>
                <TableCell>{t.slug}</TableCell>
                <TableCell>{t.planType}</TableCell>
                <TableCell>{t.status}</TableCell>
                <TableCell>{t.updatedAt ? new Date(t.updatedAt).toLocaleString() : '—'}</TableCell>
              </TableRow>
            ))}
            {!templates.length && !loading && (
              <TableRow>
                <TableCell colSpan={5}>
                  <Typography color="textSecondary">No templates found.</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PlanBuilderTemplatesIndex;



